// extracted by mini-css-extract-plugin
module.exports = {"saving":"EGetxCZ5y3KKGf9hcn6m","blink":"gy31a5MdHnG5qS1lA6m71"};